import { Link } from "react-router-dom";
import { Shield, Phone, Heart } from "lucide-react";

export const DisclaimerBanner = () => (
  <div className="bg-[#111B2C] border-b border-[#223552] text-center px-4 py-1.5 sm:py-2 text-xs text-slate-400" data-testid="disclaimer-banner">
    <span className="inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5">
      <a href="tel:988" className="inline-flex items-center gap-1 text-amber-400/90 py-1">
        <Phone className="h-3 w-3" /> Crisis support: call or text <strong className="text-amber-400">988</strong>
      </a>
      <span className="text-[#334862]">•</span>
      <span className="sm:hidden">Educational info, not legal advice.</span>
      <span className="hidden sm:inline">Educational legal information &amp; peer support — not formal legal advice or therapy.</span>
    </span>
  </div>
);

const FOOT_LINKS = [
  { heading: "Guides", links: [
    { to: "/fathers-rights", label: "Fathers' Rights" },
    { to: "/child-custody", label: "Child Custody" },
    { to: "/paternity", label: "Establishing Paternity" },
    { to: "/visitation-parent-time", label: "Visitation & Parent-Time" },
    { to: "/child-support", label: "Child Support" },
    { to: "/states", label: "State Guides" },
  ]},
  { heading: "Get Help", links: [
    { to: "/reach-out", label: "Reach Out" },
    { to: "/legal-tips", label: "Legal Tips" },
    { to: "/resources/glossary", label: "Custody Glossary" },
    { to: "/resources/first-custody-attorney-consultation", label: "First Attorney Consultation" },
    { to: "/resources/first-custody-hearing", label: "First Custody Hearing" },
    { to: "/resources/first-custody-mediation", label: "First Custody Mediation" },
    { to: "/documents", label: "Legal Documents" },
    { to: "/attorneys", label: "Find an Attorney" },
    { to: "/resources", label: "Helpful Resources" },
  ]},
  { heading: "Community", links: [
    { to: "/community", label: "Dad Forum" },
    { to: "/captains", label: "State Captains" },
    { to: "/captains#donate", label: "Donate" },
    { to: "/blog", label: "Founder's Journal" },
    { to: "/about", label: "About the Movement" },
    { to: "/contact", label: "Contact & Intake" },
  ]},
  { heading: "Legal", links: [
    { to: "/legal-disclaimer", label: "Legal Disclaimer" },
    { to: "/privacy", label: "Privacy Policy" },
    { to: "/terms", label: "Terms of Use" },
    { to: "/editorial-policy", label: "Editorial Policy" },
    { to: "/corrections-policy", label: "Corrections Policy" },
    { to: "/legal-disclaimer", label: "Community Guidelines" },
  ]},
];

export const Footer = () => (
  <footer className="bg-[#0B111E] border-t border-[#223552] mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2.5 mb-4" data-testid="footer-logo">
            <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-[#E5A93C] to-[#C86A36] flex items-center justify-center">
              <Shield className="h-5 w-5 text-[#0B111E]" strokeWidth={2.5} />
            </div>
            <span className="font-heading font-extrabold text-white text-lg">A Father's Fight</span>
          </Link>
          <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
            Standing with single fathers in all 50 states as they fight for their children with dignity, knowledge, and brotherhood.
          </p>
          <p className="mt-4 text-xs text-slate-500 inline-flex items-center gap-1.5">
            <Heart className="h-3.5 w-3.5 text-copper" /> Built by a dad who made it through, for the ones still fighting.
          </p>
        </div>
        {FOOT_LINKS.map((col) => (
          <div key={col.heading}>
            <h4 className="font-heading font-semibold text-white text-sm mb-3">{col.heading}</h4>
            <ul className="space-y-2">
              {col.links.map((l, i) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-slate-400 hover:text-amber-400 transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 pt-6 border-t border-[#223552] flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} A Father's Fight. All rights reserved.</p>
        <p className="text-xs text-slate-500 max-w-lg text-center sm:text-right">
          This website provides general educational information and emotional support only and does not constitute legal advice. Consult a licensed attorney in your state.
        </p>
      </div>
    </div>
  </footer>
);
